import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import PostListing from "@/pages/PostListing";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import PayListing from "@/pages/PayListing";
import About from "@/pages/About";
import Legal from "@/pages/Legal";

function Shell() {
  const location = useLocation();
  // Handle OAuth callback (session_id in URL fragment) before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const hideChrome = location.pathname === "/login";

  return (
    <div className="App min-h-screen flex flex-col">
      {!hideChrome && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Legal page="help" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/post" element={<ProtectedRoute><PostListing /></ProtectedRoute>} />
          <Route path="/pay/:id" element={<ProtectedRoute><PayListing /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
